<template>
    <div class="popup" v-bind:class="{ hidePopup: !isActive }">
        <div class="popup-wrapper">
            <p class="margin margin--bottom-20">Du hast bereits eine Gratispackung<br> bestellt, darfst dich aber gerne <br>weiterhin sportlich betätigen.</p>
            <button class="button" @click="hidePopupAndRedirect">
                Okay
            </button>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'Popup',
        data() {
            return {
                isActive: true
            }
        },
        methods: {
            hidePopupAndRedirect() {
                this.isActive = false;
                this.$router.push({ name: 'home'});
            },
        }

    }
</script>